/**
 * Moves the focus to the next or the previous line row of the panel (the arrow keys of design b1).
 * Returns true when the focus moved. The rows are the `role="radio"` buttons of the list.
 */
export function moveRowFocus(panel: HTMLElement, from: HTMLElement, step: 1 | -1): boolean {
  const list = panel.querySelector('[data-lyric-list]') ?? panel;
  const rows = Array.from(list.querySelectorAll<HTMLElement>('[data-lyric-row]'));
  if (rows.length === 0) {
    return false;
  }
  const index = rows.indexOf(from);
  const next = index === -1 ? rows[step === 1 ? 0 : rows.length - 1] : rows[index + step];
  if (next === undefined) {
    return false;
  }
  next.focus();
  return true;
}
